import React, {Component} from 'react';
import './AccountPage.css';
import {connect} from 'react-redux';
import actions from './profile.actions';
import {
	Dialog,
	DocumentTitle,
	FancyButton,
	FancyCheckbox,
	ShareableLink,
	Spinner
} from '../widgets';
import {sessionActions, UserType} from '../user';
import {uiActions} from '../chrome';
import {checkOnInit, checkOnPropChanges} from './profilePathCheck';

const SUBSCRIPTION_LABELS = {
	free: 'Free',
	access: 'Access',
	essentials: 'Essentials',
	premium: 'Premium'
};

const CLOSURE_OPTIONS = [
	'It is a duplicate of another login',
	'It does not serve my needs',
	'I have found a different site to promote my service',
	'It is too expensive',
	'Other'
];

class AccountPage extends Component {
	constructor(props) {
		super(props);

		checkOnInit(props);

		this.state = {
			closingAccount: false,
			reason: 'Please select a reason'
		};

		this.onReasonChange = e => {
			this.setState({reason: e.target.value});
		};
		this.closeAccountStart = () => {
			this.setState({closingAccount: true});
		};
		this.closeAccountConfirm = () => {
			if (this.state.reason !== 'Please select a reason') {
				this.props.closeAccount(this.props.profile.user.uuid, this.state.reason);
				this.setState({closingAccount: false});
			}
		};
		this.closeAccountCancel = () => {
			this.setState({closingAccount: false});
		};
	}

	componentWillReceiveProps(nextProps) {
		checkOnPropChanges(nextProps, this.props);
	}

	render() {
		if (!this.props.profile) {
			return (
				<DocumentTitle title="B2Me">
					<main className="AccountPage">
						<Spinner />
					</main>
				</DocumentTitle>
			);
		}

		const {
			profile: {
				available,
				favouritesPublic,
				notifyChat,
				notifyCommunityJoin,
				notifyCommunityUpdates,
				subscriptionLevel,
				contactVisible,
				profile: {uniqueName},
				user: {username}
			},
			persistSubscriptionLevel,
			persistFavouritesPublic,
			persistNotifyChat,
			persistNotifyCommunityJoin,
			persistNotifyCommunityUpdates,
			persistAvailability,
			persistUserType,
			persistContactVisibility,
			changeEmail,
			changePassword,
			sessionProvider,
			modal
		} = this.props;

		// prompt user to login if not
		if (!sessionProvider) {
			this.props.login();
		} else if (sessionProvider && modal === 'login') {
			this.props.closeModal(); // must close it here!
		}

		return (
			<DocumentTitle
				title={`${this.props.profile.user.firstname} ${this.props.profile.user.lastname} - B2Me`}>
				<main className="AccountPage">
					<section>
						<h2>Details</h2>
						<p className="CommunityAdminPage-note">
							Your login email is <em>{username}</em>.
						</p>
						<FancyButton onClick={changeEmail}>Change email</FancyButton>
						<FancyButton onClick={changePassword}>Change password</FancyButton>
					</section>
					<section
						className={`AccountPage-subscription ${
							subscriptionLevel === 'none' ? 'user' : 'provider'
						}`}>
						<h2>Subscription</h2>
						{SUBSCRIPTION_LABELS[subscriptionLevel] && (
							<p>
								You are currently on the <em>{SUBSCRIPTION_LABELS[subscriptionLevel]}</em> plan.
							</p>
						)}
						{!SUBSCRIPTION_LABELS[subscriptionLevel] && <p>You are not currently on a plan.</p>}
						<p>Note that this early release of B2Me is free to use</p>
						{/*, and your renewal date is <em>August 22, 2018*/}
						{/*<Link className="AccountPage-upsell" to="/">Change plan</Link>*/}
						<UserType
							confirm={true}
							checked={subscriptionLevel === 'none' ? 'user' : 'provider'}
							onChange={persistUserType}
						/>
						{/*<p>Please choose a plan from the selection below:</p>*/}
						{/*<AccountPlans className="AccountPage-plans" subscriptionLevel={subscriptionLevel} persistSubscriptionLevel={persistSubscriptionLevel} />*/}
						{/*<ol>*/}
						{/*<li className="AccountPage-fancy-checkbox">*/}
						{/*<input type="checkbox" checked="" id="auto-renew" />*/}
						{/*<label htmlFor="auto-renew">*/}
						{/*<span>Automatically renew my subscription</span>*/}
						{/*</label>*/}
						{/*</li>*/}
						{/*</ol>*/}
					</section>

					{subscriptionLevel !== 'none' && (
						<section>
							<h2>Embedding code</h2>
							<ShareableLink
								className="AccountPage-share"
								snippet={`<iframe src="${window.location.protocol}//${
									window.location.host
								}/api/embed/@${uniqueName}" frameborder="0" width="500" height="250"></iframe>`}
							/>
							<p className="CommunityAdminPage-note">
								Paste this HTML code into another website to embed it.
							</p>
						</section>
					)}

					{subscriptionLevel !== 'none' && (
						<section>
							<h2>Sharing link</h2>
							<ShareableLink
								className="AccountPage-share"
								snippet={window.location.protocol + '//' + window.location.host + '/@' + uniqueName}
							/>
							<p className="CommunityAdminPage-note">
								Share this link on Twitter, Facebook, email, and elsewhere.
							</p>
						</section>
					)}

					<section className="AccountPage-availability">
						<h2>My providers</h2>

						<ol>
							<li className="AccountPage-fancy-checkbox">
								<FancyCheckbox
									id="favourites-public"
									checked={favouritesPublic}
									onChange={persistFavouritesPublic}
								/>
								<label htmlFor="favourites-public">
									<span>I want my list of providers to be visible to others</span>
								</label>
							</li>
						</ol>
					</section>

					{subscriptionLevel !== 'none' && (
						<section className="AccountPage-availability">
							<h2>Availability</h2>

							<ol>
								<li className="AccountPage-fancy-checkbox">
									<FancyCheckbox checked={available} onChange={persistAvailability} />
									<label htmlFor="available-for-work">
										<span>Available for work</span>
									</label>
								</li>
							</ol>
						</section>
					)}

					<section className="AccountPage-privacy">
						<h2>Privacy</h2>

						<ol>
							<li className="AccountPage-fancy-checkbox">
								<FancyCheckbox
									id="contact-privacy"
									checked={contactVisible}
									onChange={persistContactVisibility}
								/>
								<label htmlFor="contact-privacy">
									<span>I want my contact information visible to non logged in users</span>
								</label>
							</li>
						</ol>
					</section>

					<section className="AccountPage-notifications">
						<h2>Notify me when…</h2>

						<ol>
							<li className="AccountPage-fancy-checkbox">
								<FancyCheckbox onChange={persistNotifyChat} checked={notifyChat} />
								<label htmlFor="notify-chat">
									<span>Someone sends me a message</span>
								</label>
							</li>
							<li className="AccountPage-fancy-checkbox">
								<FancyCheckbox
									onChange={persistNotifyCommunityJoin}
									checked={notifyCommunityJoin}
								/>
								<label htmlFor="notify-community-join">
									<span>I'm accepted into a community</span>
								</label>
							</li>
							<li className="AccountPage-fancy-checkbox">
								<FancyCheckbox
									onChange={persistNotifyCommunityUpdates}
									checked={notifyCommunityUpdates}
								/>
								<label htmlFor="notify-community">
									<span>A community I'm a member of is updated</span>
								</label>
								{/* <p className="AccountPage-note">Note: You can mute an individual community from its page.</p> */}
							</li>
						</ol>
					</section>

					<section className="AccountPage-email">
						<h2>Email</h2>

						<ol>
							<li className="AccountPage-fancy-checkbox">
								<FancyCheckbox
									onChange={this.props.persistEmailUnsub}
									checked={this.props.profile.user.unsubbedFromEmail}
									id="unsub-email"
								/>
								<label htmlFor="unsub-email">
									<span>Unsubscribe from email notifications</span>
								</label>
							</li>
						</ol>
					</section>

					<section className="AccountPage-delete">
						<h2>Close account</h2>
						<FancyButton onClick={this.closeAccountStart}>I wish to close my account</FancyButton>
						{this.state.closingAccount && (
							<Dialog
								className="compact"
								title="Close account?"
								buttons={['cancel', 'Close account']}
								disabled={
									this.state.reason === 'Please select a reason'
										? {'Close account': true}
										: {'Close account': false}
								}
								emphasis="cancel"
								onCancel={this.closeAccountCancel}
								onCloseaccount={this.closeAccountConfirm}
								onNo={this.closeAccountCancel}>
								<div className="AccountPage-deleteSorry">
									We’re sorry to see you go! We would appreciate it if you have a few moments to
									provide some feedback:
									<select onChange={this.onReasonChange} value={this.state.reason}>
										<option value="Please select a reason" disabled>
											Please select a reason
										</option>
										{CLOSURE_OPTIONS.map((op, idx) => (
											<option key={idx} value={op}>
												{op}
											</option>
										))}
									</select>
								</div>
							</Dialog>
						)}
						{this.state.closingAccount && (
							<layer className="modal" onClick={this.closeAccountCancel} />
						)}
					</section>
				</main>
			</DocumentTitle>
		);
	}
}

const ConnectedAccountPage = connect(
	({profile, reviews, session, ui}) => ({
		modal: ui.modal,
		profile,
		sessionProvider: session && session.current,
		// ISSUE: this is derived state. It doesn't really belong in mapStateToProps
		editable:
			session.current &&
			session.current.user &&
			profile &&
			(session.current.user.admin || session.current.provider.uuid === profile.uuid)
	}),
	dispatch => ({
		retrieveProfile: uniqueName => dispatch(actions.retrieveProfile(uniqueName)),
		persistSubscriptionLevel: subscriptionLevel =>
			dispatch(actions.persistProviderField({subscriptionLevel})),
		persistUserType: type => {
			dispatch(
				actions.persistProviderField({
					subscriptionLevel: type === 'user' ? 'none' : 'free'
				})
			);
			if (type === 'user') {
				dispatch(
					uiActions.uiMessage(
						`You are now a user. You can search for providers at the top of the page.`
					)
				);
			} else {
				dispatch(
					uiActions.uiMessage(
						`You are now a provider. Start entering your profile details so you can be listed.`
					)
				);
			}
		},
		persistFavouritesPublic: e =>
			dispatch(actions.persistProviderField({favouritesPublic: !!e.target.checked})),
		persistNotifyChat: e =>
			dispatch(actions.persistProviderField({notifyChat: !!e.target.checked})),
		persistNotifyCommunityJoin: e =>
			dispatch(actions.persistProviderField({notifyCommunityJoin: !!e.target.checked})),
		persistNotifyCommunityUpdates: e =>
			dispatch(
				actions.persistProviderField({
					notifyCommunityUpdates: !!e.target.checked
				})
			),
		persistAvailability: e =>
			dispatch(actions.persistProviderField({available: !!e.target.checked})),
		persistContactVisibility: e =>
			dispatch(actions.persistProviderField({contactVisible: !!e.target.checked})),
		persistEmailUnsub: e => dispatch(actions.persistEmailUnsub(!!e.target.checked)),
		closeAccount: (uuid, reason) => dispatch(sessionActions.closeAccount(uuid, reason)),
		changeEmail: () => dispatch(uiActions.uiModal('change-email')),
		changePassword: () => dispatch(sessionActions.changePassword()),
		login: () => dispatch(uiActions.uiModal('login')),
		closeModal: () => dispatch(uiActions.uiModal(null))
	})
)(AccountPage);

export default ConnectedAccountPage;



// WEBPACK FOOTER //
// ./src/profile/AccountPage.js